import {Box} from '@mui/material';

const commonProps = {
  enableRowActions: true,
  positionActionsColumn: 'last',
  enableStickyHeader: true,
  muiTableContainerProps: {
    sx: {
      // 66px - header,
      // 32px - padding Y,
      // 56px - pagination,
      // 58px - top toolbar
      maxHeight: 'calc(100dvh - 66px - 32px - 56px - 58px)',
      // --sidebar-width - width of the sidebar, it changes when the sidebar
      // is collapsed. The variable is set in DashboardLayout,
      // 32px - padding X.
      maxWidth: 'calc(100vw - var(--sidebar-width, 240px) - 32px)',
      overflowX: 'auto',
    },
  },
} as const;

export const entityTableCommonProps = {
  ...commonProps,
  renderEmptyRowsFallback: () => (
    <Box p={4} display="flex" justifyContent="center">
      No data found
    </Box>
  ),
} as const;

export const deletedEntityTableCommonProps = {
  ...commonProps,
  renderEmptyRowsFallback: () => (
    <Box p={4} display="flex" justifyContent="center">
      No data found
    </Box>
  ),
} as const;
